// src/components/MDInput.jsx
import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

// MDInputRoot bileşenini tanımlayın
const MDInputRoot = styled(TextField)(({ theme }) => ({
  // Burada stil ayarlarını yapabilirsiniz
  margin: theme.spacing(1),
  width: '100%',
}));

const MDInput = React.forwardRef(({ label, ...props }, ref) => {
  return (
    <MDInputRoot
      inputRef={ref}
      label={label}
      variant="outlined"
      {...props} // Diğer props'ları geçirin
    />
  );
});

export default MDInput;